import {Text} from '@chakra-ui/react';
import {IconBlock} from 'components/layouts/aside-layout';
import {colors} from 'components/providers';
import {SupportButtons} from 'components/shared';
import {useTranslation} from 'hooks';
import {FC} from 'react';

export const Support: FC = () => {
  const {t} = useTranslation();
  return (
    <IconBlock icon="/icons/support.svg">
      <Text fontWeight="600" mb="5px">
        {t('HELP')}
      </Text>
      <Text fontSize="14px" fontWeight="500" color={colors.textGray} mb="14px">
        {t('CALL_US')}
      </Text>
      <SupportButtons t={t} />
    </IconBlock>
  );
};
